declare const DEBUG:boolean;

export const ShareBaseConfigModule = angular
		.module('sharebase-config', [])
		.constant('debugInfoEnabled', DEBUG);

if(DEBUG){
	ShareBaseConfigModule
		.factory('fiveHundredErrorInterceptor', ['$q',($q:ng.IQService) => {
			//used to catch and display all 500 errors durring dev mode
			var _fivehundredErrors = [];

			return {
				responseError: response => {
					//status -1 is a CORS that Chrome throws on some 500 errors
					if (response && (response.status === 500 ||  response.status === -1 )) {
						_fivehundredErrors.push(response);
					}

					return $q.reject(response);
				},
				get errors(){ return _fivehundredErrors; }
			};
		}])
		.component('sbErrors', {
			template: '<div class="md-whiteframe-4dp app--background-red app-animate--scale-in" ng-if="vm.errors.length > 0" layout="row" layout-align="center center"'+
							' style="height:50px; width:50px; border-radius: 50%; position:fixed;font-size: 24px; bottom:16px;left:16px;z-index:1000">'+
							'{{vm.errors.length}}<md-tooltip md-direction="top">500 http error detected.  Check console log.</md-tooltip></div>',
			controller: [
				'fiveHundredErrorInterceptor',
				ErrorController
			],
			controllerAs: 'vm',
			bindings: {
			}
		});
}

function ErrorController(fiveHundredErrorInterceptor) {
	var vm = this;
	vm.errors = fiveHundredErrorInterceptor.errors;
}


// WEBPACK FOOTER //
// ./src/config/appConfig.ts